// extracted by mini-css-extract-plugin
export default {"media":"Notifications_media_Z0Aqb"};